import React from 'react';
import { Box, Typography, Paper, Container, Link, List, ListItem } from '@mui/material';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <Container maxWidth="md">
      <Box sx={{ py: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom fontWeight="bold">
          📄 Политика конфиденциальности
        </Typography>

        <Typography variant="body2" color="text.secondary" gutterBottom>
          Дата вступления в силу: 05.04.2026 года
        </Typography>

        <Paper sx={{ p: 4, mt: 3 }}>
          {/* 1. Общие положения */}
          <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mt: 3 }}>
            1. Общие положения
          </Typography>
          <Typography paragraph>
            Настоящая Политика конфиденциальности (далее — «Политика») определяет порядок сбора,
            хранения и использования персональных данных пользователей сервиса «nashrelax.ru»
            (далее — «Сервис»), доступного по адресу: <strong>https://nashrelax.ru</strong> и
            применяется на основании Федерального закона от 27.07.2006 № 152-ФЗ «О персональных данных».
          </Typography>
          <Typography paragraph>
            Мы уважаем вашу конфиденциальность и соблюдаем законодательство Российской Федерации,
            поэтому используем информацию о персональных данных исключительно для оказания вам
            сервисных услуг, не распространяем её и прикладываем разумные усилия для предотвращения
            несанкционированного доступа к информации и утечки данных.
          </Typography>
          <Typography paragraph>
            Политика конфиденциальности является неотъемлемой частью{' '}
            <Link href="/terms-of-service" target="_blank" rel="noopener noreferrer" underline="hover">
              Пользовательского соглашения https://nashrelax.ru
            </Link>.
          </Typography>

          {/* 2. Какие данные мы собираем */}
          <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mt: 3 }}>
            2. Какие данные мы собираем
          </Typography>
          <List dense>
            <ListItem>Фамилия, имя, отчество</ListItem>
            <ListItem>Адрес электронной почты</ListItem>
            <ListItem>Пол</ListItem>
            <ListItem>Номер телефона</ListItem>
            <ListItem>Логин</ListItem>
            <ListItem>Сведения, собираемые посредством метрических программ</ListItem>
          </List>
          <Typography paragraph>
            Также мы собираем:
          </Typography>
          <ul>
            <li>информацию о созданных вами мероприятиях, участии в мероприятиях и ваших действиях в процессе использования Сервиса;</li>
            <li>информацию, которую вы оставите в текстовых полях при описании мероприятий и условий их посещения (эта информация может быть доступна другим пользователям Сервиса).</li>
          </ul>

          {/* 3. Цели сбора данных */}
          <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mt: 3 }}>
            3. Цели сбора данных
          </Typography>
          <Typography paragraph>
            Целью сбора, хранения и обработки персональных данных является оказание услуг,
            предоставляемых Сервисом, в том числе оказание посреднических услуг при организации мероприятий:
          </Typography>
          <ul>
            <li>Идентификации пользователя в Сервисе</li>
            <li>Создания и управления мероприятиями</li>
            <li>Записи на мероприятия и участия в них</li>
            <li>Отправки уведомлений о мероприятиях</li>
            <li>Улучшения работы Сервиса</li>
            <li>Подтверждения согласия пользователя на сбор, хранение и обработку персональных данных.</li>
          </ul>

          {/* 4. Перечень действий при обработке */}
          <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mt: 3 }}>
            4. Перечень действий, осуществляемых при обработке персональных данных
          </Typography>
          <List dense>
            <ListItem>Сбор</ListItem>
            <ListItem>Запись</ListItem>
            <ListItem>Систематизация</ListItem>
            <ListItem>Накопление</ListItem>
            <ListItem>Хранение</ListItem>
            <ListItem>Уточнение (обновление, изменение)</ListItem>
            <ListItem>Извлечение</ListItem>
            <ListItem>Использование</ListItem>
            <ListItem>Передача (предоставление, доступ)</ListItem>
            <ListItem>Обезличивание</ListItem>
            <ListItem>Блокирование</ListItem>
            <ListItem>Удаление</ListItem>
          </List>

          {/* 5. Правовые основания */}
          <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mt: 3 }}>
            5. Правовые основания обработки персональных данных
          </Typography>
          <Typography paragraph>
            Обработка персональных данных осуществляется с согласия субъекта персональных данных
            на обработку его персональных данных.
          </Typography>

          {/* 6. Хранение и защита данных */}
          <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mt: 3 }}>
            6. Хранение и защита данных
          </Typography>
          <Typography paragraph>
            Мы принимаем все необходимые меры для защиты ваших данных:
          </Typography>
          <ul>
            <li>Данные хранятся на серверах на территории Российской Федерации</li>
            <li>Доступ к данным имеют только уполномоченные лица</li>
            <li>Регулярно проводятся проверки безопасности</li>
            <li>Используется межсетевой экран (UFW — Uncomplicated Firewall)</li>
            <li>Используется криптографическая защита (шифрование): применение методов шифрования для защиты данных при хранении и передаче (HTTPS — HyperText Transfer Protocol Secure)</li>
            <li>Контроль доступа: использование паролей; для авторизации на сайте используется OAuth 2.0 (открытый стандарт авторизации)</li>
          </ul>

          {/* 7. Передача данных третьим лицам */}
          <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mt: 3 }}>
            7. Передача данных третьим лицам
          </Typography>
          <Typography paragraph>
            Мы не передаём ваши персональные данные третьим лицам, за исключением:
          </Typography>
          <ul>
            <li>Случаев, предусмотренных законодательством РФ</li>
            <li>Google/Yandex для OAuth-авторизации (при условии, что вы самостоятельно выбираете данные ресурсы для авторизации в Сервисе)</li>
          </ul>

          {/* 8. Ваши права */}
          <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mt: 3 }}>
            8. Ваши права
          </Typography>
          <Typography paragraph>
            Вы имеете право:
          </Typography>
          <ul>
            <li>Получить информацию о своих персональных данных</li>
            <li>Требовать уточнения, блокирования или уничтожения данных</li>
            <li>Отозвать согласие на обработку персональных данных</li>
            <li>Требовать прекращения обработки данных</li>
            <li>Требовать иных действий Оператора в соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных»</li>
          </ul>

          {/* 9. Отзыв согласия */}
          <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mt: 3 }}>
            9. Отзыв согласия
          </Typography>
          <Typography paragraph>
            Вы можете отозвать согласие на обработку персональных данных в любой момент, написав на email:{' '}
            <strong>asc.asp@yandex.ru</strong>
          </Typography>
          <Typography paragraph>
            После отзыва согласия мы прекратим обработку данных и удалим их в течение 30 дней,
            если иное не предусмотрено законодательством.
          </Typography>

          {/* 10. Cookies и локальное хранилище */}
          <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mt: 3 }}>
            10. Cookies и локальное хранилище
          </Typography>
          <Typography paragraph>
            Сайт использует локальное хранилище браузера (localStorage) для:
          </Typography>
          <ul>
            <li>Хранения токенов авторизации</li>
            <li>Сохранения настроек фильтров</li>
          </ul>
          <Typography paragraph>
            Cookie-файлы не используются.
          </Typography>

          {/* 11. Контакты */}
          <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mt: 3 }}>
            11. Контакты
          </Typography>
          <Typography paragraph>
            По вопросам обработки персональных данных вы можете обратиться, написав на email:{' '}
            <strong>asc.asp@yandex.ru</strong>
          </Typography>
          <Typography paragraph>
            Оператором персональных данных является владелец ресурса <strong>https://nashrelax.ru</strong>{' '}
            Поляков Александр Сергеевич.
          </Typography>

          {/* 12. Изменения в Политике */}
          <Typography variant="h5" gutterBottom fontWeight="bold" sx={{ mt: 3 }}>
            12. Изменения в Политике
          </Typography>
          <Typography paragraph>
            Мы оставляем за собой право вносить изменения в Политику конфиденциальности.
            При внесении изменений в настоящее положение субъект персональных данных уведомляется
            путём размещения новой редакции Положения в Сервисе. Актуальная версия всегда доступна
            в Сервисе.
          </Typography>

          <Box sx={{ mt: 4, p: 3, bgcolor: 'warning.light', borderRadius: 2 }}>
            <Typography variant="body2">
              <strong>Важно:</strong> Используя Сервис, вы подтверждаете, что ознакомились
              с Политикой конфиденциальности и соглашаетесь на обработку персональных данных
              в соответствии с ней.
            </Typography>
          </Box>
        </Paper>

        <Box sx={{ mt: 3, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <Link href="/events" underline="hover">
            ← Вернуться к мероприятиям
          </Link>
          <Link href="/terms-of-service" underline="hover" target="_blank" rel="noopener noreferrer">
            Пользовательское соглашение →
          </Link>
          <Link href="/community-rules" underline="hover" target="_blank" rel="noopener noreferrer">
            Правила сообщества →
          </Link>
        </Box>
      </Box>
    </Container>
  );
};

export default PrivacyPolicyPage;
